export const initialValues = true;

export default initialValues;
